var _defs, _polygon, _polygon2, _line, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew299({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8.26 11.57 14.19 15 14.19 8.15 8.26 11.57"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.74 11.57 1.81 8.15 1.81 15 7.74 11.57"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8,
    y1: 5.09,
    x2: 8,
    y2: 11.57
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,1A4.09,4.09,0,0,0,3.91,5.09h8.18A4.09,4.09,0,0,0,8,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew299);
export default __webpack_public_path__ + "static/media/Symbolpack_New_299.b0833e8b284ac6c7e881029527daf63a.svg";
export { ForwardRef as ReactComponent };